import {originClick} from '../../../types';
import {TrackingClientStateHolder} from '../helpers/clientState';

export const trackOriginClick =
  ({origin}: {origin: originClick}) =>
  (
    clientState: TrackingClientStateHolder
  ): 'no event data trackOriginClick' => {
    origin && clientState.update({originClick: origin});
    return 'no event data trackOriginClick';
  };
